module.exports = __webpack_public_path__ + "img/banner_icon5.781ae826.png";